import LoginApp from './login-app';

export default LoginApp;
